import * as React from 'react';

import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

function Copyright(props) {
    return (
        <>
            <Typography variant="body2" color="text.secondary" align="center" {...props}>
                {'📦 Desarrollado por '}
                <Link color="inherit" href="https://kilogis.com/" target="_blank">
                    {'Kilogis© '}
                </Link>{' '}
                {new Date().getFullYear()}
                {'. '}
            </Typography>
        </>
    );
    }
    
export default function Dashboard() {
    return <Copyright/>;
    }